import {
  PEDIDO_STATUS_TOTAL,
  PEDIDO_LOAD,
  PEDIDO_DISABLE_BLOCK_PAYMENT,
  PEDIDO_UPDATE_PAYMENT_CHECK,
  PEDIDO_UPDATE_PAYMENT_METHOD,
  PEDIDO_UPDATE_DELIVEY_METHOD,
  PEDIDO_UPDATE_ADDRESS,
  PEDIDO_GENERATE_RECEIPT,
  PEDIDO_LOAD_DELIVEY_METHODS,
  PEDIDO_UPDATE_DELIVEY_DATE,
  PEDIDO_UPDATE_RESPONSABLE,
  PEDIDO_LOAD_LOGS,
  PEDIDO_RESEND_ERP,
  PEDIDO_PAYMENT_PENDING,
  PEDIDO_LOG,
  PEDIDO_ACTIONS_INIT_DELIVERY,
  PEDIDO_ACTIONS_CONFIRM_DELIVERY,
  PEDIDO_ACTIONS_ACCEPT_QUOTE,
  PEDIDO_ACTIONS_CONCLUDE_SEPARATION,
  PEDIDO_ACTIONS_CONCLUDE_WITHDRAWAL,
  PEDIDO_ACTIONS_CONFIRM_PAYMENT,
  PEDIDO_ACTIONS_INIT_SEPARATION,
  PEDIDO_ACTIONS_SUBMIT_QUOTE,
  PEDIDO_CANCEL,
  PEDIDO_AVALIATION,
  PEDIDO_CHAT,
  PEDIDO_CHAT_IMAGE,
  PEDIDO_CONFIG,
  PEDIDO_INSERT_PRODUCT,
  PEDIDO_DELETE_PRODUCT,
  PEDIDO_UPDATE_PRODUCT,
  PEDIDO_EXPORT_DETALHE
} from "../actions/pedido";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const state = {};

const getters = {};

const actions = {
  [PEDIDO_STATUS_TOTAL]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v2.pedido.total
        .porStatus(getters.getFornecedorId, payload.ativo, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_LOAD]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v1.pedido
        .obtemDadosPedido(getters.getFornecedorId, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_DISABLE_BLOCK_PAYMENT]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.pedido
        .disableBlockPayment(getters.getFornecedorId, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_UPDATE_PAYMENT_CHECK]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.pedido
        .updatePedidoVerificadoManualmente(
          getters.getFornecedorId,
          payload.idpedido,
          payload.value
        )
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_UPDATE_PAYMENT_METHOD]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.pedido
        .updatePaymentMethod(
          getters.getFornecedorId,
          payload.idpedido,
          payload.dadospedido.formaPagamento.idformapagto,
          payload.dadospedido.formaPagamento.quantParcelas
        )
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_UPDATE_ADDRESS]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v1.pedido
        .updateEnderecos(getters.getFornecedorId, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_GENERATE_RECEIPT]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.pedido
        .generateReceipt(
          getters.getFornecedorId,
          payload.numpedido,
          payload.idcliente
        )
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_LOAD_DELIVEY_METHODS]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.formaEntrega
        .getFormasPedido(
          getters.getFornecedorId,
          payload.idpedido,
          payload.idendereco,
          payload.idcliente
        )
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_UPDATE_DELIVEY_METHOD]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v1.pedido
        .updateFormaEntrega(getters.getFornecedorId, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_UPDATE_DELIVEY_DATE]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.pedido
        .updateDeliveryDate(
          getters.getFornecedorId,
          payload.idpedido,
          payload.dataentregatimestamp
        )
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_UPDATE_RESPONSABLE]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.pedido
        .updateResponsable(getters.getFornecedorId, payload.idpedido, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_LOAD_LOGS]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.pedido
        .getLogsEvento(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_RESEND_ERP]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.pedido
        .reenviarParaErp(getters.getFornecedorId, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_PAYMENT_PENDING]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.pedido
        .reanalisePaymentPending(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_ACTIONS_INIT_DELIVERY]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v1.pedido
        .iniciarEntregaPedido(
          getters.getFornecedorId,
          payload.numpedido,
          payload.idcliente
        )
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_LOG]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.pedido
        .logManual(getters.getFornecedorId, payload.numpedido, payload.status)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_ACTIONS_CONFIRM_DELIVERY]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v1.pedido
        .confirmarEntregaPedido(
          getters.getFornecedorId,
          payload.numpedido,
          payload.idcliente
        )
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_ACTIONS_ACCEPT_QUOTE]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v1.pedido
        .aceitarOrcamento(
          getters.getFornecedorId,
          payload.numpedido,
          payload.idcliente
        )
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_ACTIONS_CONCLUDE_SEPARATION]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v1.pedido
        .concluirSeparacaoPedido(
          getters.getFornecedorId,
          payload.numpedido,
          payload.idcliente,
          payload.tipoentrega
        )
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_ACTIONS_CONCLUDE_WITHDRAWAL]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v1.pedido
        .concluirRetiradaPedido(
          getters.getFornecedorId,
          payload.numpedido,
          payload.idcliente
        )
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_ACTIONS_CONFIRM_PAYMENT]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v1.pedido
        .confirmarPagamentoManual(
          getters.getFornecedorId,
          payload.numpedido,
          payload.idcliente,
          payload.statuspedido,
          payload.idformapagamento
        )
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_ACTIONS_INIT_SEPARATION]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v1.pedido
        .iniciarSeparacaoPedido(
          getters.getFornecedorId,
          payload.numpedido,
          payload.idcliente
        )
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_ACTIONS_SUBMIT_QUOTE]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v1.pedido
        .submeterOrcamentoParaPedido(
          getters.getFornecedorId,
          payload.numpedido,
          payload.idcliente
        )
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_CANCEL]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v1.pedido
        .cancelarPedido(
          getters.getFornecedorId,
          payload.numpedido,
          payload.idcliente,
          payload.idusuario,
          payload.estorno
        )
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_AVALIATION]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v1.pedido
        .obtemAvaliacao(getters.getFornecedorId, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_CHAT]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v1.pedido
        .obtemMensagensChat(getters.getFornecedorId, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_CHAT_IMAGE]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.pedido
        .sendOrderChatFile(
          getters.getFornecedorId,
          payload.idpedido,
          payload.formData
        )
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_CONFIG]: ({ dispatch, getters }) => {
    return new Promise((resolve, reject) => {
      Api.v2.config
        .orderConfig(getters.getFornecedorId)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_INSERT_PRODUCT]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v1.pedido
        .inserirItemPedido(
          getters.getFornecedorId,
          payload.numpedido,
          payload.idproduto
        )
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_UPDATE_PRODUCT]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v1.pedido
        .alterarPropriedadesItemPedido(
          getters.getFornecedorId,
          payload.numpedido,
          payload.id,
          payload
        )
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_DELETE_PRODUCT]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v1.pedido
        .removerItemPedido(
          getters.getFornecedorId,
          payload.numpedido,
          payload.itemid,
          payload.indisponivel
        )
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PEDIDO_EXPORT_DETALHE]: ({ dispatch, getters }, idpedido) => {
    return new Promise((resolve, reject) => {
      Api.v4.pedido
        .exportarPedidoDetalhe(getters.getFornecedorId, idpedido)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
